import AssociatesReport from './AssociatesReportPage';

export default AssociatesReport;
